import { useFetcher, useLoaderData, useNavigate } from "@remix-run/react";
import { useTranslation } from "react-i18next";
import BlogBox from "~/components/blog/BlogBox";
import { loader } from "./route";
import { EMAIL_SUBSCRIBED_STORAGE } from "~/utils/constants";
import useLocalStorage from "~/utils/hooks/useLocalStorage";
import { useEffect, useState } from "react";
import SubscribeEmailPopup from "~/components/blog/SubscribeEmailPopup";
import useHost from "~/utils/hooks/useHost";
import { set } from "lodash";
import React from "react";

export async function action() {
  console.log("here i am");
  return null;
}

export default function Webinar() {
  const { blog, locale, otherWebinars, toast } = useLoaderData<typeof loader>();
  const { t } = useTranslation("blog");
  const downloadRef = React.useRef<HTMLAnchorElement>(null);

  const [subscribed, setSubscribed] = useLocalStorage(
    EMAIL_SUBSCRIBED_STORAGE,
    false,
  );

  const [showForm, setShowForm] = useState(false);
  const host = useHost();

  const handleDownloadClick = () => {
    if (subscribed) {
      downloadRef.current?.click();
    } else {
      setShowForm(true);
    }
  };

  useEffect(() => {
    if ((subscribed || toast?.type === "success") && showForm) {
      downloadRef.current?.click();
      setShowForm(false);
    }
  }, [subscribed, showForm, toast]);

  return (
    <div>
      <BlogBox
        blog={blog}
        imgRatio="lg:aspect-square aspect-square sm:aspect-[8/3]"
        imgClassName="lg:min-w-[530px] p-6 rounded-2xl bg-Secondary-Dark-Blue-db-50 lg:h-[530px] "
        containerClassName="lg:flex-row-reverse lg:gap-10"
        locale={locale}
        page={true}
      />

      <button
        onClick={handleDownloadClick}
        className="btn mt-6 text-xl font-bold"
      >
        {t("download this book")}
      </button>

      {showForm && !subscribed && (
        <div className="fixed left-0 top-0 z-50 flex h-full w-full items-center justify-center">
          <div
            className="absolute left-0 top-0 h-full w-full bg-black bg-opacity-50"
            onClick={() => setShowForm(false)}
          ></div>
          <SubscribeEmailPopup title="enterEmailBook" button="downloadNow" />
        </div>
      )}
      <a
        href={host + blog.attributes.bookPdf.data?.attributes.url}
        ref={downloadRef}
        target="_blank"
      ></a>
    </div>
  );
}
